// extracted by mini-css-extract-plugin
module.exports = {"coupon":"CouponCode_coupon__rAQ78","content":"CouponCode_content__wDWiE","button":"CouponCode_button__jTgw4","input":"CouponCode_input__AwL_u"};